import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { InventoryTags } from "./InventoryTags";

export interface InventorySyncOutcome {
  ok: boolean;
  error?: string;
}

export interface InventorySyncResult {
  cin7: InventorySyncOutcome;
  estore: InventorySyncOutcome;
}

/** "Sync now" (POST /inventory-syncs): every source's current levels into our inventory (Cin7, then eStore), each reported on its own. */
export const createInventorySyncApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createInventorySync: builder.mutation<InventorySyncResult, void>({
      queryFn: async () => {
        try {
          const res = await axios.post<InventorySyncResult>(
            `${backendBase()}/inventory-syncs`,
            {},
            { headers: { Accept: "application/json" } },
          );
          return { data: res.data };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      invalidatesTags: [{ type: InventoryTags.Inventory, id: "LIST" }],
    }),
  }),
});

export const createInventorySync = createInventorySyncApi.endpoints.createInventorySync;
